// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file luwu/v1/forward.proto (package luwu.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Error } from "./common_pb";
import { file_luwu_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file luwu/v1/forward.proto.
 */
export const file_luwu_v1_forward: GenFile = /*@__PURE__*/
  fileDesc("ChVsdXd1L3YxL2ZvcndhcmQucHJvdG8SB2x1d3UudjEiGwoLRm9yd2FyZE9wZW4SDAoEcG9ydBgBIAEoDSI6Cg1Gb3J3YXJkT3BlbmVkEgoKAm9rGAEgASgIEh0KBWVycm9yGAIgASgLMg4ubHV3dS52MS5FcnJvciI8CgtGb3J3YXJkUG9ydBIMCgRwb3J0GAEgASgNEgwKBG5hbWUYAiABKAkSEQoJbGlzdGVuaW5nGAMgASgIQihaJmx1d3UuZGV2L2dvL2ludGVybmFsL3BiL2x1d3UvdjE7bHV3dXYxYgZwcm90bzM", [file_luwu_v1_common]);

/**
 * /luwu/forward/1.0.0 — one stream per TCP connection to a port on the
 * computer's own localhost. The dialer sends ForwardOpen, the computer
 * answers ForwardOpened; after that the stream carries the raw bytes.
 * Only ports the computer's owner allowed there are forwarded.
 *
 * @generated from message luwu.v1.ForwardOpen
 */
export type ForwardOpen = Message<"luwu.v1.ForwardOpen"> & {
  /**
   * @generated from field: uint32 port = 1;
   */
  port: number;
};

/**
 * Describes the message luwu.v1.ForwardOpen.
 * Use `create(ForwardOpenSchema)` to create a new message.
 */
export const ForwardOpenSchema: GenMessage<ForwardOpen> = /*@__PURE__*/
  messageDesc(file_luwu_v1_forward, 0);

/**
 * @generated from message luwu.v1.ForwardOpened
 */
export type ForwardOpened = Message<"luwu.v1.ForwardOpened"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: luwu.v1.Error error = 2;
   */
  error?: Error | undefined;
};

/**
 * Describes the message luwu.v1.ForwardOpened.
 * Use `create(ForwardOpenedSchema)` to create a new message.
 */
export const ForwardOpenedSchema: GenMessage<ForwardOpened> = /*@__PURE__*/
  messageDesc(file_luwu_v1_forward, 1);

/**
 * A port the computer allows forwarding to.
 *
 * @generated from message luwu.v1.ForwardPort
 */
export type ForwardPort = Message<"luwu.v1.ForwardPort"> & {
  /**
   * @generated from field: uint32 port = 1;
   */
  port: number;

  /**
   * e.g. "Screen" for 5900
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * something accepts connections on it right now
   *
   * @generated from field: bool listening = 3;
   */
  listening: boolean;
};

/**
 * Describes the message luwu.v1.ForwardPort.
 * Use `create(ForwardPortSchema)` to create a new message.
 */
export const ForwardPortSchema: GenMessage<ForwardPort> = /*@__PURE__*/
  messageDesc(file_luwu_v1_forward, 2);

